import { http } from '../common/http-client'
import { joinPath } from '../common/url-util'
import { DEFAULT_CONTEXT_PATH } from '../common/constants'
import { redirectToLocation } from '../common/redirect'

/**
 * Gets auth server change password url calling ATAPI route passwordChange, and does redirection
 * The url includes a redirect_uri so once the change password action is done, user will be redirected there
 *
 * @param {string} contextPath - The home path of the ATAPI passwordChange route (e.g. /api)
 */
export function doPasswordChange(contextPath = DEFAULT_CONTEXT_PATH) {
    return async () => {
        const url = joinPath(contextPath, 'passwordChange')
        const res = await http.post(url, null, { credentials: 'include' })
        const passwordChangeUrl = res && res.data && res.data.passwordChangeUrl
        if (!passwordChangeUrl) {
            return null
        }
        redirectToLocation(passwordChangeUrl, 'sameWindow')
    }
}
